import EmptyWrap from "@/components/Gui/EmptyWrap";

export default [
    {
        path: 'city',
        component: EmptyWrap,
        children: [
            {
                path: '',
                name: 'city.list',
                component: require('@/views/City/CityList').default,
            },
            {
                path: 'create',
                name: 'city.create',
                component: require('@/views/City/CityForm').default,
            },
            {
                path: ':id',
                component: require('@/views/City/Card/WrapBlock').default,
                children: [
                    {
                        path: 'detail',
                        name: 'city.detail',
                        component: require('@/views/City/Card/CityDetail').default,
                    },
                    {
                        path: 'district',
                        name: 'city.district',
                        component: require('@/views/City/Card/DistrictTab').default,
                    },
                ]
            },
            {
                path: ':id/edit',
                name: 'city.edit',
                component: require('@/views/City/CityForm').default,
            },
        ]
    },
]